import Store from '@/vuex/store';
import { color_warning } from '@liveflight/resources/colors';
import { flight_offer_average_duration } from '@liveflight/utilities/flight-duration';

export const sorting_options = {
  best: {
    icon: '',
    title: 'Migliore',
    description: 'Migliore',
    info: 'Combinazione ottimale di prezzo, durata e numero di scali rispetto a tutti i risultati trovati.',
    color: '#36773F',
    background: '#D7F0DB',
  },
  price: {
    icon: '',
    title: 'Prezzo',
    description: 'Più economico',
    info: 'Il volo con il prezzo più basso tra tutti i risultati della ricerca.',
    color: '#246D78',
    background: '#D1ECF1',
  },
  duration: {
    icon: '',
    title: 'Durata',
    description: 'Più veloce',
    info: 'Il volo con la durata minore tra tutti i risultati della ricerca.',
    color: color_warning,
    background: '#FFF3CD',
  },
};

export const get_sorting = () => Store.state.liveflight.sort_by;

export const is_current_sorting = (sorting) => Store.state.liveflight.sort_by === sorting;

export const set_sorting = (sorting) => {
  Store.commit('liveflight/sort_by', sorting);
};

export function sort_flight_offers(flights, rankings = {}) {
  if (!flights) return [];

  const sorted = flights.map((f) => {
    const average_duration = flight_offer_average_duration(f, false);
    return {
      ...f,
      sort_duration: average_duration,
      rank: rankings[f.id] ? rankings[f.id].rank : f.price.grandTotal * average_duration,
    };
  });

  const sort_key = Store.state.liveflight.sort_by;
  switch (sort_key) {
    case 'price':
      sorted.sort((a, b) => {
        return a.price.grandTotal - b.price.grandTotal;
      });
      break;

    case 'duration':
      sorted.sort((a, b) => {
        return a.sort_duration - b.sort_duration;
      });
      break;

    case 'best':
      sorted.sort((a, b) => {
        return a.rank - b.rank;
      });
      break;

    default:
      break;
  }

  return sorted;
}
